import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useReducer,
  useRef,
  useState,
} from 'react'
import { RouterProps, useNavigate, useParams, Link } from 'react-router-dom'
import logo from '../logo.svg'
import './PageContent.scss'
import { Helmet } from 'react-helmet-async'
import SideMenu from '../components/SideMenu'
import store, {
  RootState,
  AppDispatch,
  useAppDispatch,
  notesSlice,
  methods,
  reducer,
} from '../store'
import { useSelector, useDispatch } from 'react-redux'
import { bindEvent } from '../modules/bindEvent'
import { useTranslation } from 'react-i18next'
import { snackbar, prompt, alert, progressBar } from '@saki-ui/core'
import { AES, Debounce, images } from '@nyanyajs/utils'

import { Header } from '../components'
import { api } from '../modules/electron/api'
import * as http from '../modules/http/api'
import { CategoryItem, NoteItem, PageItem } from '../store/notes/typings'
import { ReaderRouterProps } from '../modules/renderRoutes'
import { resolve } from 'path'
import { rejects } from 'assert'
import { SyncOff } from './Icon'
import { configSlice, eventListener, saass } from '../store/config'
import { IContext } from '../store'
import { log } from 'console'
import { decryptContent, encryptContent, getPwd } from '../modules/methods'
import { protoRoot } from '../protos'
import { pid } from 'process'
import {
  getImportanceColor,
  getParentIds,
  getSubTodoIds,
  getTodoProgress,
  getTopParentId,
} from '../store/notes/todolist'
import TodoListContentPage from './TodoListContentPage'
import {
  SakiAsideModal,
  SakiButton,
  SakiIcon,
  SakiInput,
} from './saki-ui-react/components'
import { getCatalog } from '../store/catalog'
import md5 from 'blueimp-md5'

let fileProgressBar = progressBar()
const PageContentComponent = ({
  // onClick,
  page,
  sync,
  noteId,
  categoryId,
}: {
  noteId: string
  categoryId: string
  sync: boolean
  page?: protoRoot.note.IPageItem
  // onClick: ({ id }: { id: string }) => void
}) => {
  const { t, i18n } = useTranslation()
  const dispatch = useDispatch<AppDispatch>()
  const notes = useSelector((state: RootState) => state.notes)
  const config = useSelector((state: RootState) => state.config)
  const catalog = useSelector((state: RootState) => state.catalog)
  const autoCloseWindowAfterCopy = useSelector(
    (state: RootState) => state.config.general.autoCloseWindowAfterCopy
  )

  const showSelectTypeOfAddPage = useSelector(
    (state: RootState) =>
      state.config.pageConfig.indexPage.showSelectTypeOfAddPage
  )

  let history = useNavigate()
  const ref = useRef<any>(null)
  const [richtextEl, setRichtextEl] = useState<HTMLSakiRichtextElement>()

  const [pwd, setPwd] = useState('')
  const [pwdError, setPwdError] = useState('')
  const [pageTitle, setPageTitle] = useState('')
  const [pageContent, setPageContent] = useState('')
  const [lastSyncTime, setLastSyncTime] = useState(0)

  const [showPageContent, setShowPageContent] = useState(false)
  const [showTodoListContent, setShowTodoListContent] = useState(false)
  const [capsLocked, setCapsLocked] = useState(false)

  const [showFindInPage, setShowFindInPage] = useState(false)
  const [findText, setFindText] = useState('')
  const [findTextResult, setFindTextResult] = useState<
    {
      startIndex: number
      endIndex: number
    }[]
  >([])
  const [findTextResultIndex, setFindTextResultIndex] = useState(-1)
  const findInPageEl = useRef<HTMLInputElement>()
  const findInPageDebounce = useRef(new Debounce())
  const findTexteDebounce = useRef(new Debounce())

  useEffect(() => {
    if (!page?.id || page?.type === 'TodoList') return setShowFindInPage(false)

    // console.log('textt', page.content?.length)
    // console.log(
    // 	'textt aes',
    // 	'adsadsad',
    // 	AES.encrypt(page.content, 'adsadsad').value?.length
    // )
    // console.log(
    // 	'textt aes',
    // 	md5('adsadsad'),
    // 	AES.encrypt(page.content, md5('adsadsad')).value?.length
    // )

    eventListener.removeEvent('findInPage')
    eventListener.on('findInPage', async () => {
      // el.setSelectionRange(startIndex, endIndex, "forward");
      setShowFindInPage(true)
      // const focus = await richtextEl?.getFocus()
      const text = window.getSelection()?.toString() || ''
      // console.log('findInPage', text)
      setFindText(text)

      findInPageDebounce.current.increase(() => {
        const inputEl = findInPageEl.current?.querySelector('input')
        console.log(inputEl)
        if (!inputEl) return
        inputEl.setSelectionRange(0, text.length, 'forward')
        inputEl.focus()
      }, 10)
    })
  }, [richtextEl, page])

  useEffect(() => {
    findText &&
      findTexteDebounce.current.increase(async () => {
        const editorEl = richtextEl?.querySelector(
          '.ql-editor'
        ) as HTMLDivElement
        if (!editorEl) return

        const result = await getFindTextIndex(
          editorEl.innerText || '',
          findText,
          0
        )
        // editorEl.innerHTML = await addFindTextHighlight(
        // 	editorEl,
        // 	editorEl.innerHTML,
        // 	findText,
        // 	0
        // )

        console.log('result', result)

        setFindTextResult(result)
        setFindTextResultIndex(-1)
      }, 300)
  }, [findText, page?.content])

  const setSelection = (index: number) => {
    console.log('setSelection', index)
    index = index < 0 ? findTextResult.length - 1 : index
    index = index > findTextResult.length - 1 ? 0 : index
    setFindTextResultIndex(index)
    const editorEl = richtextEl?.querySelector('.ql-editor') as any
    if (!editorEl) return
    const val = findTextResult[index]
    // console.log(val, 'findTextResult', findTextResultIndex, findTextResult)
    // editorEl?.setSelectionRange(val.startIndex, val.endIndex, 'forward')
    // editorEl.focus()
    richtextEl?.setSelection(val.startIndex, val.endIndex - val.startIndex)
  }

  const getFindTextIndex = async (
    content: string,
    findText: string,
    startIndex: number
  ): Promise<typeof findTextResult> => {
    if (!content || !findText) return []

    const reg = new RegExp(findText, 'ig')
    const quill = (await richtextEl?.getQuill()) as any
    const text = quill.getText()
    let matches = [...text.matchAll(reg)]

    return matches.map((v) => {
      return {
        startIndex: v.index,
        endIndex: v.index + findText.length,
      }
    })

    // const si = content.indexOf(findText, startIndex)
    // if (si < 0) return []
    // const ei = si + findText.length
    // console.log(content.slice(si, ei))
    // getSelection()
    // console.log(si, ei)
    // return [
    // 	{
    // 		startIndex: si,
    // 		endIndex: ei,
    // 	},
    // ].concat(getFindTextIndex(content, findText, si + 1))
  }
  const getContent = (page: protoRoot.note.IPageItem) => {
    if ((page?.encryption || 0) >= 1) {
      if (page?.id && notes.pwdObj[page?.id]?.pwd) {
        console.log(
          'getContent decryptContent',
          page,
          1,
          notes.pwdObj[page?.id].pwd,
          2
        )
        const val = decryptContent(
          page?.content || '',
          notes.pwdObj[page?.id].pwd
        )
        console.log('getContent', val, 1, notes.pwdObj[page?.id].pwd, 2)
        return val
      }
    }
    return page.content
  }

  useEffect(() => {
    if (!page || page.type === 'TodoList') return
    getCatalog()
    // }
  }, [page])

  useEffect(() => {
    console.log('changepage', page, page?.type, !page)
    if (!page) return

    setPwd('')

    setPageTitle(page?.title || '')

    if (page.type === 'TodoList') return

    const pc = getContent(page) || ''
    setPageContent(pc)

    // console.log('ccccc changepage pc1', pc?.length, !!richtextEl)
  }, [page, notes.lastSyncTime, richtextEl])

  useEffect(() => {
    // console.time('ccccc')
    const pc = pageContent
    // console.log('ccccc,changepage pc2', pc?.length, !!richtextEl)
    richtextEl?.getFocus?.().then((isFocus: boolean) => {
      // console.log('isFocus', isFocus, lastSyncTime, notes.lastSyncTime)

      // console.log('ccccc changepage pc3', pc.length)
      // console.timeEnd('ccccc')
      if (lastSyncTime !== notes.lastSyncTime) {
        richtextEl?.setValue?.(pc)
        setLastSyncTime(notes.lastSyncTime)
        return
      }
      if (!isFocus) {
        richtextEl?.setValue?.(pc)
      }
    })
  }, [pageContent])

  useEffect(() => {
    console.log('setShowPageContent', page?.id, notes.pwdObj)

    if ((page?.encryption || 0) >= 1) {
      if (page?.id && notes.pwdObj[page?.id]?.pwd) {
        console.log(notes.pwdObj[page?.id]?.pwd)
        setShowPageContent(true)
        return
      }
      setShowPageContent(false)
      return
    }
    setShowPageContent(true)
  }, [notes.pwdObj, page])

  const upload = (file: File) => {
    return new Promise((resolve, reject) => {
      let reader = new FileReader()
      reader.onload = async (e) => {
        if (!e.target?.result) return
        const hash = saass.getHash(e.target.result)
        console.log('hash', hash)
        console.log('file', file)

        // lastModified: 1659813176641
        // lastModifiedDate: Sun Aug 07 2022 03:12:56 GMT+0800 (China Standard Time) {}
        // name: "PngItem_1211108.png"
        // size: 11202
        // type: "image/png"
        // webkitRelativePath: ""

        // string name = 1;
        // int64 size = 2;
        // string type = 3;
        // string Suffix = 4;
        // int64 LastModified = 5;
        // string Hash = 6;
        const res = await http.api.v1.getUploadToken({
          fileInfo: {
            name: file.name,
            size: file.size,
            type: file.type,
            suffix: '.' + file.name.substring(file.name.lastIndexOf('.') + 1),
            lastModified: file.lastModified,
            hash: hash,
          },
        })
        console.log('getUploadToken', res)
        if (res.code === 200) {
          saass.setBaseUrl(res.data.urls?.domainUrl || '')
          //         apiUrl: "http://192.168.0.106:16100/api/v1/chunkupload/upload"
          // chunkSize: 262144
          // token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJmaWxlSW5mbyI6eyJBcHBJZCI6IjFlODE2OTE0LTY0ZDItNDc3YS04ZTM1LTQyN2Q5NDdlY2Y1MCIsIk5hbWUiOiJQbmdJdGVtXzEyMTExMDgucG5nIiwiRW5jcnlwdGlvbk5hbWUiOiI4NmZlYmJhNTdiY2NkOGExODNhMTkyZWM2OTRmNzUzNSIsIlBhdGgiOiIvRjA5MzVFNENENTkyMEFBNkM3Qzk5NkE1RUU1M0E3MEYvZmlsZXMvIiwiVGVtcEZvbGRlclBhdGgiOiIuL3N0YXRpYy9jaHVjay8wMzJhYzZhMjQ2ZWI3ZTUxZTM3Mzc3YzNhYmE4YjM2NzE1NGZiMTUxMDFhOTI3NzY2NDA0MDRlMDlhZjkwMGJkLyIsIlRlbXBDaHVja0ZvbGRlclBhdGgiOiIuL3N0YXRpYy9jaHVjay8wMzJhYzZhMjQ2ZWI3ZTUxZTM3Mzc3YzNhYmE4YjM2NzE1NGZiMTUxMDFhOTI3NzY2NDA0MDRlMDlhZjkwMGJkLy9jaHVjay8iLCJDaHVua1NpemUiOjEzMTA3MiwiQ3JlYXRlVGltZSI6MTY1OTg5NDkwNCwiRXhwaXJhdGlvblRpbWUiOi0xLCJWaXNpdENvdW50IjotMSwiRmlsZUluZm8iOnsiTmFtZSI6IlBuZ0l0ZW1fMTIxMTEwOCIsIlNpemUiOjExMjAyLCJUeXBlIjoiaW1hZ2UvcG5nIiwiU3VmZml4IjoiLnBuZyIsIkxhc3RNb2RpZmllZCI6MTY1OTgxMzE3NjY0MSwiSGFzaCI6IjAzMmFjNmEyNDZlYjdlNTFlMzczNzdjM2FiYThiMzY3MTU0ZmIxNTEwMWE5Mjc3NjY0MDQwNGUwOWFmOTAwYmQifSwiRmlsZUNvbmZsaWN0IjoiUmVwbGFjZSJ9LCJleHAiOjE2NTk5ODEzMDQsImlzcyI6InNhYXNzIn0.nfwmBNpJAMCK31U_vG4dL3mRvkhKb7EnaAqji29X9Hw"
          // uploadedOffset: []
          // urls: Urls
          // domainUrl: "http://192.168.0.106:16100"
          // encryptionUrl: "/s/86febba57bccd8a183a192ec694f7535"
          // url: "/s/F0935E4CD5920AA6C7
          const data: any = res.data
          if (data.token) {
            saass.uploadFile({
              file: file,
              url: data.apiUrl,
              token: data.token,
              chunkSize: data.chunkSize,
              uploadedOffset: data.uploadedOffset || [],
              uploadedTotalSize: data.uploadedTotalSize || 0,
              async onprogress(options) {
                // console.log('options', options)
                // await store.state.storage.staticFileWS.getAndSet(
                // 	upload.data.urls?.encryptionUrl || '',
                // 	async (v) => {
                // 		return {
                // 			...v,
                // 			fileDataUrl: result || '',
                // 			uploadedSize: options.uploadedSize,
                // 			totalSize: options.totalSize,
                // 		}
                // 	}
                // )
              },
              async onsuccess(options) {
                // console.log('options', options)
                resolve(data.urls?.domainUrl + data.urls?.shortUrl)
                // await store.state.storage.staticFileWS?.getAndSet(
                // 	upload.data.urls?.encryptionUrl || '',
                // 	async (v) => {
                // 		return {
                // 			...v,
                // 			fileDataUrl: result || '',
                // 			encryptionUrl: options.encryptionUrl,
                // 			url: options.url,
                // 			uploadedSize: file.size,
                // 			totalSize: file.size,
                // 		}
                // 	}
                // )
                // store.dispatch('chat/sendMessageWidthSecretChatApi', {
                // 	messageId,
                // 	dialogId,
                // })
              },
              onerror(err) {
                resolve('')
                console.log('error', err)

                // store.dispatch('chat/failedToSendMessage', {
                // 	messageId,
                // 	dialogId,
                // })
              },
            })
          } else {
            resolve(data.urls?.domainUrl + res.data.urls?.shortUrl || '')
          }
        } else {
          resolve('')
        }
      }
      reader.readAsArrayBuffer(file)
    })
  }

  const uploadFile = async (type: 'Image' | 'Video') => {
    let imgInput = document.createElement('input')
    imgInput.type = 'file'
    imgInput.multiple = true
    switch (type) {
      case 'Image':
        // 目前暂时仅支持PNG和JPG
        imgInput.accept = 'image/*'
        break
      case 'Video':
        imgInput.accept = 'video/*'
        // imgInput.accept = 'image/*'
        break
      // case 'File':
      // 	imgInput.accept = '*'
      // 	break

      default:
        break
    }
    let index = 0
    const up = async (files: FileList, index: number) => {
      try {
        if (index >= files.length) {
          fileProgressBar.setProgress({
            progress: 1,
            tipText: 'Uploaded successfully',
            onAnimationEnd() {
              fileProgressBar.close()
            },
          })
          return
        }

        const file = files[index]

        if (type === 'Image') {
          console.time('开始Resize图片')
          const resizeData = await images.resize(file, {
            maxPixel: 1920,
            quality: 0.7,
            platform: 'wasm',
          })
          console.timeEnd('开始Resize图片')

          console.log('file', file)
          console.log('resizeData', resizeData)

          // 转换为Uint8Array

          if (!resizeData) return
          // richtextEl?.insetNode({
          // 	type: type,
          // 	src: resizeData.dataURL,
          // })

          // console.log(bytes)
          // fileProgressBar.setProgress({
          // 	progress: 1,
          // 	tipText: 'Uploading',
          // 	onAnimationEnd() {
          // 		fileProgressBar.close()
          // 	},
          // })
          // console.log(resizeData.arrayBuffer)
          // console.log(resizeData.arrayBuffer?.buffer)
          // const b = new Blob([resizeData.arrayBuffer?.buffer as any], {
          // 	type: file.type,
          // })
          // console.log(b)
          // const cFile = new File([b], file.name, {
          //   type: file.type,
          // })
          // const res = await upload(cFile)
          const res = await upload(resizeData.file)
          console.log('resizeData', res)
          if (res) {
            console.log(res)

            fileProgressBar.setProgress({
              progress: index + 1 / files.length,
              tipText: 'Uploading',
              onAnimationEnd() {
                fileProgressBar.close()
              },
            })

            index++

            richtextEl?.insetNode({
              type: type,
              src: res + config.saassConfig.parameters.imageResize.normal,
              className: '',
              alt: '',
              title: '',
              name: '',
            })
            up(files, index)
          } else {
            fileProgressBar.setProgress({
              progress: 1,
              tipText: 'Upload failed',
              onAnimationEnd() {
                fileProgressBar.close()
              },
            })
            index++
          }
        }
        if (type === 'Video') {
          // console.time('开始Resize Video')
          // const resizeData = await videos.resize(file, {
          // 	maxPixel: 1920,
          // 	quality: 0.7,
          // 	platform: 'wasm',
          // })
          // console.timeEnd('开始Resize Video')
          // console.log('file', file)
          // console.log('resizeData', resizeData)
          // fileProgressBar.setProgress({
          // 	progress: 1,
          // 	tipText: 'Uploading',
          // 	onAnimationEnd() {
          // 		fileProgressBar.close()
          // 	},
          // })
        }
      } catch (error) {
        fileProgressBar.setProgress({
          progress: 1,
          tipText: 'Upload failed',
          onAnimationEnd() {
            fileProgressBar.close()
          },
        })
      }
    }
    imgInput.oninput = async (e) => {
      console.log(imgInput?.files)
      if (imgInput?.files?.length) {
        index = 0
        fileProgressBar.open()
        up(imgInput?.files, index)
      }
    }
    imgInput.click()
  }

  const changeTitle = async (title: string) => {
    setPageTitle(title)
    page?.id &&
      dispatch(
        notesSlice.actions.updatePage({
          noteId: noteId,
          categoryId: categoryId,
          pageId: page?.id || '',
          data: {
            title: title,
          },
        })
      )
  }
  const enterPasswordEvent = () => {
    let tempPwd = getPwd(pwd)
    console.log('enterPasswordEvent', page, pwd, tempPwd)
    if (!page) return
    if (!pwd) {
      setPwdError(
        t('passwordCannotBeEmpty', {
          ns: 'common',
        })
      )
      return
    }

    const content = decryptContent(page.content || '', tempPwd)
    console.log('decryptContent', content)

    if (!content) {
      snackbar({
        message: t('wrongPasswordPleaseReEnter', {
          ns: 'common',
        }),
        vertical: 'top',
        horizontal: 'center',
        autoHideDuration: 2000,
        closeIcon: true,
      }).open()
      return
    }
    console.log(content)
    const obj = {
      ...notes.pwdObj,
    }
    obj[page?.id || ''] = {
      pwd: tempPwd,
      validTime: Math.floor(new Date().getTime() / 1000) + 10 * 3600,
    }
    dispatch(notesSlice.actions.setPwdObj(obj))

    setPwd('')
    setPageContent(content)
  }

  return (
    <div className="page-content-component">
      {page?.id ? (
        <>
          <div className="p-title">
            {(page?.encryption || 0) >= 1 ? (
              <div
                onClick={() => {
                  console.log(notes.pwdObj[page?.id || '']?.pwd)

                  notes.pwdObj[page?.id || '']?.pwd &&
                    alert({
                      title: t('reencryptThisPage', {
                        ns: 'common',
                      }),
                      content: t('reencryptThisPageContent', {
                        ns: 'common',
                      }),
                      cancelText: t('cancel', {
                        ns: 'common',
                      }),
                      confirmText: t('reencrypt', {
                        ns: 'common',
                      }),
                      onCancel() {},
                      async onConfirm() {
                        const obj = {
                          ...notes.pwdObj,
                        }
                        delete obj[page.id || '']
                        dispatch(notesSlice.actions.setPwdObj(obj))
                      },
                    }).open()
                }}
              >
                <saki-icon
                  color="#999"
                  width="18px"
                  height="18px"
                  margin="0 6px 0 0"
                  type={notes.pwdObj[page?.id]?.pwd ? 'Unlock' : 'Lock'}
                ></saki-icon>
              </div>
            ) : page.type === 'TodoList' ? (
              <saki-icon
                color="#999"
                width="18px"
                height="18px"
                margin="0 6px 0 0"
                type={'TodoListFill'}
              ></saki-icon>
            ) : (
              ''
            )}
            <saki-input
              ref={bindEvent({
                clearvalue: async (e) => {
                  // console.log('clearvalue', e)
                  dispatch(
                    notesSlice.actions.updatePage({
                      noteId: noteId,
                      categoryId: categoryId,
                      pageId: page.id || '',
                      data: {
                        title: '',
                      },
                    })
                  )
                },
                changevalue: (e) => {
                  if (
                    !config.pageConfig.disableChangeValue &&
                    page.title !== e.detail
                  ) {
                    changeTitle(e.detail)
                  }
                },
              })}
              width="100%"
              height="56px"
              padding="0 0px"
              font-size="24px"
              value={pageTitle}
              placeholder={t('untitledPage', {
                ns: 'indexPage',
              })}
            />
          </div>
          <div className="p-content scrollBarHover">
            {showPageContent ? (
              page?.type === 'TodoList' ? (
                <TodoListContentPage
                  noteId={noteId}
                  categoryId={categoryId}
                  page={page}
                />
              ) : (
                <div className="p-c-richtext">
                  <saki-richtext
                    ref={bindEvent(
                      {
                        clearvalue: (e) => {
                          console.log('clearvalue', e)
                        },
                        handlers: (e) => {
                          console.log('handlers', e)
                          let el: any = e.target

                          switch (e.detail.handler) {
                            case 'Image':
                              uploadFile('Image')
                              // el?.insetNode({
                              // 	type: 'Image',
                              // 	src: 'http://localhost:16100/s/0d33575b32e77d7e5fce40746efe3ea6?x-saass-process=image/resize,160,70',
                              // })
                              // const getImg = await useOss({
                              // 	num: 9,
                              // 	type: 'Picture',
                              // 	token: this.token,
                              // 	userAgent: {
                              // 		os: this.os,
                              // 		browser: this.browser,
                              // 		device: this.device,
                              // 		deviceId: this.deviceId,
                              // 	},
                              // 	language: this.language,
                              // })
                              // getImg?.forEach((item: any) => {
                              // 	this.quillEditor.insetNode({
                              // 		type: 'Image',
                              // 		src: item.url,
                              // 	})
                              // })

                              break
                            case 'Video':
                              uploadFile('Video')
                              // const getVideo = await useOss({
                              // 	num: 1,
                              // 	type: 'Video',
                              // 	token: this.token,
                              // 	userAgent: {
                              // 		os: this.os,
                              // 		browser: this.browser,
                              // 		device: this.device,
                              // 		deviceId: this.deviceId,
                              // 	},
                              // 	language: this.language,
                              // })
                              // getVideo?.forEach((item: any) => {
                              // 	this.quillEditor.insetNode({
                              // 		type: 'Video',
                              // 		src: item.url,
                              // 	})
                              // })

                              break

                            default:
                              break
                          }
                        },
                        changevalue: async (e) => {
                          // console.log('eeee', e)
                          // console.log(
                          // 	'changevalue',
                          // 	notes.list[notes.list.length - 1],
                          // 	e.detail,
                          // 	page,
                          // 	page.id
                          // )

                          let content = e.detail.richText

                          if ((page.encryption || 0) >= 1) {
                            if (!notes.pwdObj[page?.id || '']?.pwd) {
                              return
                            }
                            content = encryptContent(
                              content,
                              notes.pwdObj[page?.id || '']?.pwd
                            )
                          }

                          // console.log('cvcvcvcvcvcvcvcv', page.content, content)

                          if (
                            !config.pageConfig.disableChangeValue &&
                            page.content !== content
                          ) {
                            dispatch(
                              notesSlice.actions.updatePage({
                                noteId: noteId,
                                categoryId: categoryId,
                                pageId: page.id || '',
                                data: {
                                  content,
                                },
                              })
                            )
                          }
                        },
                        pressenter: (e) => {
                          console.log('pressenter', e)
                        },
                      },
                      (e: any) => {
                        setRichtextEl(e as any)
                        e?.setToolbar?.({
                          container: [
                            'bold',
                            'italic',
                            'underline',
                            'strike',
                            'blockquote',
                            'code-block',
                            // { header: 1 },
                            // { header: 2 },
                            { script: 'sub' },
                            { script: 'super' },
                            { indent: '-1' },
                            { indent: '+1' },
                            { size: ['small', false, 'large', 'huge'] },
                            { header: [1, 2, 3, 4, 5, 6, false] },
                            { color: [] },
                            { background: [] },
                            { list: 'ordered' },
                            { list: 'bullet' },
                            { direction: 'rtl' },
                            { align: [] },
                            'link',
                            'image',
                            // 'video',
                            'clean',
                          ],
                        })
                      }
                    )}
                    theme="snow"
                    editor-padding="10px 20px 10px 20px"
                    toolbar-padding="0 13px"
                    font-size="14px"
                    border-radius="0"
                    min-length="0"
                    max-length="10000"
                    value={pageContent}
                    placeholder={t('enterContent', {
                      ns: 'indexPage',
                    })}
                  />
                </div>
              )
            ) : (
              ''
            )}

            {(page?.encryption || 0) >= 1 && !showPageContent ? (
              <div className="p-c-input-pwd">
                <div className="p-c-i-ipt">
                  <saki-dropdown
                    horizontal="Left"
                    floating-direction="Left"
                    vertical="Top"
                    visible={capsLocked}
                    offset-y="-70"
                  >
                    <saki-input
                      ref={bindEvent({
                        changevalue: (e) => {
                          if (!e.detail.length) {
                            setPwdError(
                              t('passwordCannotBeEmpty', {
                                ns: 'common',
                              })
                            )
                          } else {
                            setPwdError('')
                          }
                          setPwd(e.detail)
                          console.log(e.detail, e.detail.length)
                        },
                        pressenter: () => {
                          enterPasswordEvent()
                        },
                        inputElement: (e: CustomEvent<HTMLInputElement>) => {
                          console.log('inputElement', e)
                          if (e?.detail) {
                            e.detail.onmouseup = (e) => {
                              setCapsLocked(e.getModifierState('CapsLock'))
                            }
                            e.detail.onkeyup = (e) => {
                              setCapsLocked(e.getModifierState('CapsLock'))
                            }
                          }
                        },
                      })}
                      height="50px"
                      padding="0 25px"
                      font-size="18px"
                      value={pwd}
                      error={pwdError}
                      max-length="32"
                      border="1px solid var(--saki-default-color)"
                      border-radius="25px 0 0 25px"
                      type="Password"
                      placeholder={t('enterPassword', {
                        ns: 'common',
                      })}
                    />
                    <div
                      slot="main"
                      style={{
                        padding: '10px 10px',
                      }}
                    >
                      {t('capsLocked', {
                        ns: 'common',
                      })}
                    </div>
                  </saki-dropdown>

                  <saki-button
                    ref={bindEvent({
                      tap: () => {
                        enterPasswordEvent()
                      },
                    })}
                    height="50px"
                    border-radius="0 25px 25px 0"
                    padding="0px 24px 0 18px"
                    type="Primary"
                  >
                    <span className="p-c-i-i-btn">
                      {t('view', {
                        ns: 'common',
                      })}
                    </span>
                  </saki-button>
                </div>
                {/* <span>此页内容属加密笔记，需输入密码方可查看</span> */}
                <div className="p-c-i-tip">
                  <span>
                    {/* The content of this page is an encrypted note and requires a
                      password to be viewed. */}

                    {t('enterPasswordContent', {
                      ns: 'common',
                    })}
                  </span>
                </div>
              </div>
            ) : (
              ''
            )}
          </div>
          <div className="p-data">
            {page.type === 'Normal' ? (
              <SakiIcon
                onClick={() => {
                  setShowFindInPage(!showFindInPage)
                }}
                color={showFindInPage ? 'var(--saki-default-color)' : '#999'}
                width="14px"
                height="14px"
                type="Magnifier"
                margin="2px 0 0"
                className="p-d-sync"
              ></SakiIcon>
            ) : (
              ''
            )}
            <div className="p-d-sync">
              {sync ? (
                ''
              ) : (
                <SyncOff
                  style={{
                    width: '14px',
                    height: '14px',
                    transform: 'translateY(2px)',
                  }}
                />
              )}
            </div>
            <div className="p-d-words">
              {page.type === 'Normal'
                ? page?.content?.replace(/<\/?.+?>/g, '').length
                : page.type === 'TodoList'
                  ? page?.todoList
                      ?.map((v) => (v.title || '') + (v.note || ''))
                      .join('')?.length
                  : 0}
            </div>
          </div>
          {page.type !== 'TodoList' ? (
            <div
              onClick={() => {
                const { notes, config } = store.getState()
                if (config.pageConfig.asideContentModal.visible) {
                  dispatch(
                    configSlice.actions.setShowAsideContentModal({
                      visible: false,
                    })
                  )
                  return
                }
                const { noteId, categoryId, pageId } = notes
                dispatch(
                  configSlice.actions.setShowAsideContentModal({
                    visible: true,
                    data: {
                      noteId,
                      categoryId,
                      pageId,
                      todoId: '',
                      type: 'Catalog',
                    },
                  })
                )
              }}
              className="p-catalog-button"
            >
              {catalog.catalogs
                .filter((_, i) => i <= catalog.showBaseCatalogMaxIndex)
                .map((v, i) => {
                  return (
                    <div
                      key={i}
                      className={
                        'catalog-item ' +
                        ((
                          catalog.activeCatalogId.index >=
                          catalog.showBaseCatalogMaxIndex
                            ? catalog.showBaseCatalogMaxIndex === i
                            : v.id === catalog.activeCatalogId.id
                        )
                          ? 'active'
                          : '')
                      }
                    ></div>
                  )
                })}
            </div>
          ) : (
            ''
          )}
          {/* <div className='p-findinpage'>
              <saki-aside-modal
                ref={bindEvent({
                  close: () => {
                    setShowFindInPage(false)
                  },
                })}
                vertical='Bottom'
                horizontal='Right'
                visible={showFindInPage}
                width="250px"
                height='50px'
                background-color='#fff'
                border-radius='10px 0px 0px 10px'
                offset-x="10px"
                offset-y="10px"
              >
                ces
              </saki-aside-modal>
            </div> */}
        </>
      ) : (
        ''
      )}
      <SakiAsideModal
        ref={
          bindEvent({
            close: () => {
              setShowFindInPage(false)
            },
          }) as any
        }
        vertical="Top"
        horizontal="Right"
        visible={showFindInPage}
        background-color="#fff"
        border-radius="10px 0px 0px 10px"
        offset-x="0px"
        offset-y="50px"
      >
        <div className="find-in-page-modal">
          <div className="fip-input">
            <SakiInput
              onChangevalue={(e) => {
                setFindText(e.detail)
              }}
              onFocusfunc={async () => {
                const quill = await richtextEl?.getQuill()
                quill.disable()
              }}
              onBlurfunc={async () => {
                const quill = await richtextEl?.getQuill()
                quill.enable()
              }}
              onPressenter={async (e) => {
                // console.log('onPressenter', e, await richtextEl?.getQuill())
                // setTimeout(() => {
                // 	// setTimeout(() => {
                // 	// 	const inputEl = findInPageEl.current?.querySelector('input')
                // 	// 	if (!inputEl) return
                // 	// 	console.log(inputEl)
                // 	// 	inputEl.focus()
                // 	// }, 50)
                // }, 50)
                setSelection(findTextResultIndex + 1)
              }}
              padding="8px 4px 8px 0px"
              backgroundColor="#eee"
              width="130px"
              borderRadius="8px"
              placeholder={t('findInPage', {
                ns: 'indexPage',
              })}
              value={findText}
              ref={findInPageEl as any}
            ></SakiInput>
            <span className="fip-count">{`${findTextResultIndex + 1}/${
              findTextResult.length
            }`}</span>
          </div>

          <SakiButton
            onTap={() => {
              setSelection(findTextResultIndex - 1)
            }}
            width="26px"
            height="26px"
            margin="0 0 0 2px"
            type="CircleIconGrayHover"
          >
            <SakiIcon
              width="13px"
              height="13px"
              color="#666"
              type="ArrowTop"
            ></SakiIcon>
          </SakiButton>
          <SakiButton
            onTap={() => {
              setSelection(findTextResultIndex + 1)
            }}
            width="26px"
            height="26px"
            margin="0 0 0 2px"
            type="CircleIconGrayHover"
          >
            <SakiIcon
              width="13px"
              height="13px"
              color="#666"
              type="ArrowBottom"
            ></SakiIcon>
          </SakiButton>
          <SakiButton
            onTap={() => {
              setFindText('')
              setShowFindInPage(false)
            }}
            width="26px"
            height="26px"
            margin="0 0 0 2px"
            type="CircleIconGrayHover"
          >
            <SakiIcon
              width="13px"
              height="13px"
              color="#666"
              type="Close"
            ></SakiIcon>
          </SakiButton>
        </div>
      </SakiAsideModal>
    </div>
  )
}

export default PageContentComponent
